import React, { useState } from "react";
import "../../index.css";
import "../../App.css";
import { Row, Input, Switch, Typography } from "antd";
import { useSelector, useDispatch } from "react-redux";
import { RootState, AppDispatch } from "./../../redux-toolkit/store/store";
import {
  handleChangeShowNotes,
  handleUpdateNotes,
} from "../../redux-toolkit/slices/painEntryFormSlice";

const TeAddNotes = () => {
  const painEntryForm = useSelector((state: RootState) => state.painEntryForm);
  const { showNotes, notes } = painEntryForm;
  const dispatch = useDispatch();
  const handleSwitchChange = (checked: boolean) => {
    dispatch(handleChangeShowNotes(checked));
  };

  return (
    <div className="flex flex-col gap-2">
      <label className="h6 text-theme-text-secondary">
        <strong>Want to add notes to this entry?</strong>
      </label>
      <p className="body1 text-theme-text-primary mb-4">
        You'll get a better snapshot in the future.
      </p>
      <div style={{ marginBottom: "10px" }}>
        <Switch
          checked={showNotes}
          onChange={handleSwitchChange}
          checkedChildren="On"
          unCheckedChildren="Off"
        />
      </div>
      {showNotes && (
        <Input.TextArea
          rows={3}
          placeholder="Write your notes here"
          value={notes}
          onChange={(e) => {
            dispatch(handleUpdateNotes(e.target.value));
          }}
          className="w-full px-4 py-3 border border-neutral-300 rounded-lg focus:border-primary-500 focus:ring-2 focus:ring-primary-200 focus:outline-none transition-all duration-200 bg-white custom-placeholder"
        />
      )}
    </div>
  );
};

export default TeAddNotes;
